import { render } from "./uploadImage.vue?vue&type=template&id=1fbc4cfa"
import script from "./uploadImage.vue?vue&type=script&lang=js"
export * from "./uploadImage.vue?vue&type=script&lang=js"

import "./uploadImage.vue?vue&type=style&index=0&id=1fbc4cfa&rel=stylesheet%2Fscss&lang=scss"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/uploadImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fbc4cfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fbc4cfa', __exports__)) {
    api.reload('1fbc4cfa', __exports__)
  }
  
  module.hot.accept("./uploadImage.vue?vue&type=template&id=1fbc4cfa", () => {
    api.rerender('1fbc4cfa', render)
  })

}


export default __exports__